import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, Suspense, useEffect, useRef, useState } from 'react';
import Notifications from '@views/Notifications';
import { LoadingOverlay } from '@components';
import { useAuth } from '@lib/authentication';
import { useConnectionChange } from '@lib/connectionChange';
import { useProfile } from '@lib/profile';
import { useInsightsService } from '@lib/insightsService';
import { dropInvestorSession } from '@lib/insightsService/useInsightsService';
import PrivateRoutes from './private/PrivateRoutes';
import PublicRoutes from './public/PublicRoutes';
const AppRoutes = () => {
    const { setInvestorSession } = useInsightsService();
    const [isInitializing, setIsInitializing] = useState(true);
    const { token, isAuthenticated, isLoading: isLoadingAuthentication } = useAuth();
    const { profile, isLoading: isLoadingProfile } = useProfile();
    const { hasConnectionChangeError } = useConnectionChange();
    const isLoading = isLoadingAuthentication || isLoadingProfile;
    const hasAuthenticatedProfile = isAuthenticated && Boolean(profile);
    const [privateRoutesKey, setPrivateRoutesKey] = useState(0);
    const wasConnectionChangeError = useRef(hasConnectionChangeError);
    useEffect(() => {
        if (!isLoading && profile) {
            setIsInitializing(false);
            setInvestorSession();
        }
        else if (!isAuthenticated && !token) {
            setIsInitializing(false);
            dropInvestorSession();
        }
    }, [isLoading, profile]);
    // Once the connection change error clears (e.g. the user renews the session
    // via the modal), remount the private routes so the views that were blocked
    // fetch their data again instead of staying stuck on the failed request.
    useEffect(() => {
        if (wasConnectionChangeError.current && !hasConnectionChangeError) {
            setPrivateRoutesKey(previousKey => previousKey + 1);
        }
        wasConnectionChangeError.current = hasConnectionChangeError;
    }, [hasConnectionChangeError]);
    if (isInitializing) {
        return _jsx(LoadingOverlay, {});
    }
    return (_jsx(Suspense, { fallback: _jsx(LoadingOverlay, {}), children: hasAuthenticatedProfile
            ? (_jsxs(Fragment, { children: [_jsx(Notifications, {}), _jsx(PrivateRoutes, {}, privateRoutesKey)] }))
            : (_jsx(PublicRoutes, {})) }));
};
export default AppRoutes;
